export const getProvidersForWalletConnectNetworkType = (providers, networkType) => providers.filter(provider => provider.capabilities?.walletConnectRegistry?.networkTypes.includes(networkType));
